// extracted by mini-css-extract-plugin
module.exports = {"TestList":"TestList__TestList--25iGX"};